import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { MOBILE_PAYOUT } from 'constants/automation';
import { useFormatCurrency } from 'hooks/useFormatCurrency';

import styles from './styles.module.scss';

type PayoutProps = {
  payout: number | string;
  isLandscape: boolean;
};

const Payout = ({ payout, isLandscape }: PayoutProps) => {
  const { t } = useTranslation();

  const { noFormattedAmount: formattedPayout } = useFormatCurrency(payout || 0, '', {
    noRounding: true,
    isCheckIndian: true
  });

  return (
    <p
      className={classNames(styles.payout, {
        [styles.payout__landscape]: isLandscape
      })}
      data-auto={MOBILE_PAYOUT}
    >
      {t('betslip.labels.payout')}:{' '}
      <span
        className={classNames(styles.payout__value, {
          [styles.payout__value__landscape]: isLandscape
        })}
      >
        {formattedPayout}
      </span>
    </p>
  );
};

export default Payout;
